import { styled } from '@linaria/react';
import { bodyFont, fonts, semantic, space } from '../../theme/tokens';

export const Card = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${space[3]};
  border: 1px solid ${semantic.border.default};
  border-radius: 8px;
  padding: ${space[5]};
`;

export const HeaderRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: ${space[3]};
`;

export const CardTitle = styled.span`
  font-family: ${bodyFont};
  font-size: ${fonts.size.sm};
  color: ${semantic.text.primary};
`;

export const NotesArea = styled.div`
  display: flex;
`;
